export function isNullOrWhitespace(value) {
    return !value || value.trim() == '';
}

export function formatCardNumber(str) {
    const cleaned = ('' + str).replace(/\D/g, '');
    return (
        cleaned.substring(0, 4) +
		' ' +
		cleaned.substring(4, 8) +
		' ' +
		cleaned.substring(8, 12) +
		' ' +
		cleaned.substring(12, str.length)
    );
}

export function formatCpfNumber(str) {
    const cleaned = ('' + str).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{3})(\d{2})$/);

    if (match) {
        return `${match[1]}.${match[2]}.${match[3]}-${match[4]}`;
    }

    return null;
}

export function formatPhoneNumber(str) {
    const cleaned = ('' + str).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{2})(\d{5})(\d{4})$/);

    if (match) {
        return `(${match[1]}) ${match[2]}-${match[3]}`;
    }

    return null;
}

export function formatZipCode(str) {
    const cleaned = ('' + str).replace(/\D/g, '');
    return cleaned.substring(0, 5) + '-' + cleaned.substring(5, cleaned.length);
}
